import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PricingProfileResponse from '../../../models/responseTypes/PricingProfileResponse';

export type PricingProfileState = {
  profiles: PricingProfileResponse[];
};

export const initialState: PricingProfileState = {
  profiles: [],
};

const pricingProfileSlice = createSlice({
  name: 'pricingProfile',
  initialState,
  reducers: {
    setPricingProfile: (
      state,
      action: PayloadAction<PricingProfileResponse[]>,
    ): void => {
      state.profiles = action.payload;
    },
  },
});

export const { setPricingProfile } = pricingProfileSlice.actions;

export default pricingProfileSlice.reducer;
